<template>
  <div class="vip-rule-box" v-html="content">
    {{ content }}
  </div>
</template>

<script>
// Color API迁移：引入Color网关标准请求方法
// fetchColorGet: 用于VIP规则页面的API调用和灰度控制
import {fetchColorGet} from "@/plugins/axiosColor";

export default {
  name: 'vipRule',
  data () {
    return {
      type: 'open', // 协议类型： open 开卡须知， author： 授权
      inviteId: "",
      content: '' // 协议内容
    }
  },
  methods: {
    // 获取协议内容
    async getRuleContent() {
      let data = ''
      // Color网关：使用标准化的functionId和参数格式
      const functionId = this.type === 'open' ? 'interact_share_fission_getVenderBindAgre' : 'interact_share_fission_getPlatformAgre'
      data = await fetchColorGet(functionId, {inviteId: this.inviteId})
      this.content = data
    }
  },
  created() {
    this.type = this.$route.query.type;
    this.inviteId = this.$route.query.inviteId;
    this.getRuleContent()
  }
}

</script>

<style lang="scss" scoped>
.vip-rule-box {
  padding: 20px;
  font-size: 12px;
  color: #2a2a2a;
  margin: 0 0 10px;
  line-height: 18px;
  text-align: justify;
}
</style>
